import Hero from '../components/sections/Hero';
import About from '../components/sections/About/About';
import Partners from '../components/sections/Partners/Partners';
import Promo from '../components/sections/Promo/Promo';
export default function LandingPage({ conference = {} } = {}) {

    return `
        <div class="landing-page">
            ${Hero({ conference })}
            ${Promo({ conference })}
            ${About({ conference })}
            ${Partners({ conference })}
        </div>
    `;
}
